/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />

namespace Teva {
    export class SlideOrFade {
        static Toggle($Element: JQuery, Visible?) {
            if (Visible == null)
                Visible = !$Element.is(":visible");
            if (Visible)
                SlideOrFade.Show($Element);
            else
                SlideOrFade.Hide($Element);
        }
        static Show($Element: JQuery, Duration = 400, CompleteCallback = null) {
            if (window.innerWidth <= 850)
                $Element.fadeIn(Duration, CompleteCallback);
            else
                $Element.slideDown(Duration, CompleteCallback);
        }
        static Hide($Element: JQuery, Duration = 400, CompleteCallback = null) {
            if (window.innerWidth <= 850)
                $Element.fadeOut(Duration, CompleteCallback);
            else
                $Element.slideUp(Duration, CompleteCallback);
        }
    }
}